const GITHUB_BASE = "https://api.github.com"
import {BaseProvider} from './gitUtils'

export default class GithubProvider < BaseProvider
	get headers
		{'Accept': 'application/vnd.github.object'}

	def getRef
		const res = await global.fetch("{GITHUB_BASE}/repos/{owner}/{repo}/git/extract-ref/HEAD")
		const result = await res.json!
		result.ref

	def loadFolderContent({fullPath})
		fullPath = "" if fullPath = '/'
		const res = await global.fetch "{GITHUB_BASE}/repos/{owner}/{repo}/contents/{fullPath}"
		const result = await res.json!
		# console.log "::res gh", result, fullPath
		result.map do(item)
			fullPath: item.path
			isDirectory: type == 'dir'
			path: item.path.replace(fullPath, '').replace('/', '')

	def loadFileContent({fullPath})
		const res = await global.fetch "{GITHUB_BASE}/repos/{owner}/{repo}/contents/{fullPath}"
		const result = await res.json!
		if result.encoding == 'base64'
			global.atob result.content
		else
			result.content
